import { apiSlice } from './baseApi';
import { DEFAULT_PAGE_LIMIT } from '@constants/appDefaults';

export const invoiceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInvoices: builder.query({
      query: ({ companyId, tableFilterOutcomingData, page, limit = DEFAULT_PAGE_LIMIT }) => ({
        url: '/invoice/get-all-invoice',
        method: 'POST',
        body: {
          company_id: companyId,
          tableFilterOutcomingData,
          page,
          limit,
        },
      }),
      transformResponse: (response) => ({
        invoices: response?.invoices ?? [],
        totalPages: response?.totalPages ?? 1,
        allTimeSum: response?.allTimeSum ?? 0,
      }),
      providesTags: ['Invoices'],
    }),
    getInvoicesByUsers: builder.query({
      query: ({ operatorId, tableFilterOutcomingData, page, limit = DEFAULT_PAGE_LIMIT }) => ({
        url: '/invoice/get-invoices-by-users',
        method: 'POST',
        body: {
          operator_id: operatorId,
          tableFilterOutcomingData,
          page,
          limit,
        },
      }),
      transformResponse: (response) => ({
        invoices: response?.invoices ?? [],
        totalPages: response?.totalPages ?? 1,
        allTimeSum: response?.allTimeSum ?? 0,
      }),
      providesTags: ['Invoices'],
    }),
    changeInvoicePayStatus: builder.mutation({
      query: (body) => ({
        url: '/invoice/change-invoice-pay-status',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Invoices', 'Orders', 'ServiceItems', 'AccountCodeAmounts'],
    }),
    deleteInvoice: builder.mutation({
      query: (body) => ({
        url: '/invoice/delete-invoice',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Invoices', 'Orders', 'ServiceItems', 'AccountCodeAmounts'],
    }),
    changeInvoiceDate: builder.mutation({
      query: (body) => ({
        url: '/invoice/change-invoice-date',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Invoices', 'Orders', 'AccountCodeAmounts'],
    }),
    editInvoiceSimple: builder.mutation({
      query: (body) => ({
        url: '/invoice/edit-invoice-simple',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Invoices', 'Orders', 'AccountCodeAmounts'],
    }),
    addInvoice: builder.mutation({
      query: (body) => ({
        url: '/invoice/add-new-invoice',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Invoices', 'Orders', 'ServiceItems', 'Customers', 'AccountCodeAmounts'],
    }),
    editInvoice: builder.mutation({
      query: (body) => ({
        url: '/invoice/edit-invoice',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Invoices', 'Orders', 'AccountCodeAmounts'],
    }),
    updateInvoiceWizard: builder.mutation({
      query: (body) => ({
        url: '/invoice/update-invoice-wizard',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Invoices', 'Orders', 'ServiceItems', 'Customers', 'AccountCodeAmounts'],
    }),
  }),
});
